module.exports = "/images/vendor/flag-icon-css/flags/1x1/bh.svg?90ad3cbd95a2834f0a787db075cdb4fc";